export const COURSES_LIST = [
  'B.Tech',
  'B.E',
  'BCA',
  'B.Sc',
  'B.Com',
  'BBA',
  'MBA',
  'MCA',
  'M.Tech',
  'M.Sc',
  'M.Com',
  'Diploma',
  'PhD',
  'Other'
];

export const getPassingYears = (pastYears = 10, futureYears = 4): number[] => {
  const currentYear = new Date().getFullYear();
  const years: number[] = [];
  // Past years
  for (let i = pastYears; i > 0; i--) {
    years.push(currentYear - i);
  }
  // Current year
  years.push(currentYear);
  // Future years
  for (let i = 1; i <= futureYears; i++) {
    years.push(currentYear + i);
  }
  return years.sort((a, b) => a - b); // Ascending order: previous years first, then current year, then future years
};
